export default __webpack_public_path__ + "static/media/Artboard 11.9cb14dad.png";